<div class="mainContent">

  <div>
    <div>
      <label i18n="@@spmsUserReg" class="textColour" [ngStyle]="{'border-color':backgroundColorButton}">Report
        Template</label>
      <span class="example-spacer"></span>
    </div>
  </div>

  <div style="height:75vh;overflow: auto;padding-left: 4%;padding-right: 4%;">
    <form novalidate [formGroup]="templatecreationmaster">

      <div class="row topRowMargins">
        <div class="col-lg-1"></div>
        <div class="col-lg-10">
          <mat-form-field appearance="outline">
            <mat-label>Template Name</mat-label>
            <input matInput type="text" formControlName="reportTemplateName"
                   [(ngModel)]="templateCreationData.reportTemplateName" required>
                   <mat-error *ngFor="let validation of validation_messages.reportTemplateName">
                    <span
                        *ngIf="templatecreationmaster.get('reportTemplateName').hasError(validation.type) && (templatecreationmaster.get('reportTemplateName').dirty || templatecreationmaster.get('reportTemplateName').touched)">
                        {{ validation.message }}
                    </span>
                </mat-error>
          </mat-form-field>
        </div>
        <div class="col-lg-1"></div>
      </div>

      <div class="row topRowMargins">
        <div class="col-lg-1"></div>
        <div class="col-lg-10">
          <mat-form-field appearance="outline">
            <mat-label>Template Description</mat-label>
            <textarea matInput style="height: 40px;"  placeholder="Template Description" formControlName="reportTemplateDescription" id="defferedObjects" [(ngModel)]="this.templateCreationData.reportTemplateDescription"></textarea>
            <mat-error *ngFor="let validation of validation_messages.reportTemplateDescription">
              <span
                  *ngIf="templatecreationmaster.get('reportTemplateDescription').hasError(validation.type) && (templatecreationmaster.get('reportTemplateDescription').dirty || templatecreationmaster.get('reportTemplateDescription').touched)">
                  {{ validation.message }}
              </span>
          </mat-error>
          </mat-form-field>
        </div>
        <div class="col-lg-1"></div>
      </div>
      <div class="row topRowMargins">
        <div class="col-lg-1"></div>
        <div class="col-lg-10" style="text-align: center;">
          <mat-form-field appearance="outline">
            <mat-label i18n="@@RCselectschedule">Report Type</mat-label>
            <mat-select (selectionChange)="reportType($event.value)"
                        formControlName="reportType" [(ngModel)]="this.templateCreationData.reportType">
              <mat-option>None</mat-option>
              <mat-option *ngFor="let reporttypedropdown of reportTypedropdown" [value]="reporttypedropdown.lookupvalueid">
                {{reporttypedropdown.lookupvalue}}
              </mat-option>
            </mat-select>
            <mat-error *ngFor="let validation of validation_messages.reportType">
              <span
                  *ngIf="templatecreationmaster.get('reportType').hasError(validation.type) && (templatecreationmaster.get('reportType').dirty || templatecreationmaster.get('reportType').touched)">
                  {{ validation.message }}
              </span>
          </mat-error>
          </mat-form-field>
        </div>
        <div class="col-lg-1"></div>
      </div>
      <div *ngIf="reportTypeName ==='RB'">

        <div class="row topRowMargins">
          <div class="col-lg-1"></div>
          <div class="col-lg-10" style="text-align: center;">
            <mat-form-field appearance="outline">
              <mat-label i18n="@@RCselectfilter">Report Binder Type</mat-label>
              <mat-select [(ngModel)]="templateCreationData.binderType"
                          (selectionChange)="binderTypeSelection($event.value)" formControlName="binderType" >
                <mat-option>None</mat-option>
                <mat-option *ngFor="let binderType of binderTypes"
                            [value]="binderType.name">
                  {{binderType.label }}
                </mat-option>
              </mat-select>
              <mat-error *ngFor="let validation of validation_messages.binderType">
                <span
                    *ngIf="templatecreationmaster.get('binderType').hasError(validation.type) && (templatecreationmaster.get('binderType').dirty || templatecreationmaster.get('binderType').touched)">
                    {{ validation.message }}
                </span>
            </mat-error>
            </mat-form-field>
          </div>
          <div class="col-lg-1"></div>
        </div>

        <div *ngIf="templateCreationData.binderType=='vault'">
          <div class="row topRowMargins">
            <div class="col-lg-1"></div>
            <div class="col-lg-10" style="text-align: center;">
              <mat-form-field appearance="outline">
                <mat-label i18n="@@RCselectfilter">Vault Binder Template</mat-label>
                <mat-select [(ngModel)]="templateCreationData.vaultBinderTemplate"
                            (selectionChange)="VaultbindSelect($event.value)" formControlName="vaultBinderTemplate" >
                  <mat-option>None</mat-option>
                  <mat-option *ngFor="let vaultBinderTemplateValues of vaultBinderTemplateDropDown"
                              [value]="vaultBinderTemplateValues.name__v">
                    {{vaultBinderTemplateValues.label__v }}
                  </mat-option>
                </mat-select>
                <mat-error *ngFor="let validation of validation_messages.vaultBinderTemplate">
                  <span
                      *ngIf="templatecreationmaster.get('vaultBinderTemplate').hasError(validation.type) && (templatecreationmaster.get('vaultBinderTemplate').dirty || templatecreationmaster.get('vaultBinderTemplate').touched)">
                      {{ validation.message }}
                  </span>
              </mat-error>
              </mat-form-field>
            </div>
            <div class="col-lg-1"></div>
          </div>
        </div>
        <div *ngIf="templateCreationData.binderType=='s3'">
          <div class="row topRowMargins">
            <div class="col-lg-1"></div>
            <div class="col-lg-10" style="text-align: center;">
              <mat-form-field appearance="outline">
                <mat-label i18n="@@RCselectfilter">Merge Sub Reports</mat-label>
                <mat-select [(ngModel)]="templateCreationData.mergeReports"
                            formControlName="mergeReports" >
                  <mat-option *ngFor="let mergeReport of mergeReports"
                              [value]="mergeReport.name">
                    {{mergeReport.label }}
                  </mat-option>
                </mat-select>
                <mat-error *ngFor="let validation of validation_messages.vaultBinderTemplate">
                  <span
                      *ngIf="templatecreationmaster.get('vaultBinderTemplate').hasError(validation.type) && (templatecreationmaster.get('vaultBinderTemplate').dirty || templatecreationmaster.get('vaultBinderTemplate').touched)">
                      {{ validation.message }}
                  </span>
              </mat-error>
              </mat-form-field>
            </div>
            <div class="col-lg-1"></div>
          </div>
          <div class="row topRowMargins">
            <div class="col-lg-1"></div>
            <div class="col-lg-10" style="text-align: center;">
              <mat-form-field appearance="outline">
                <mat-label i18n="@@RCselectfilter">Dataset</mat-label>
                <mat-select [(ngModel)]="this.templateCreationData.datasetId"
                            formControlName="datasetId"
                            (selectionChange)="retriveManageFilters($event.value)">
                  <mat-option>None</mat-option>
                  <mat-option *ngFor="let datasetValues of datasetDropDown" [value]="datasetValues.reportcreationid">
                    {{datasetValues.datasetname}}
                  </mat-option>
                </mat-select>
                <mat-error *ngFor="let validation of validation_messages.datasetId">
                  <span
                      *ngIf="templatecreationmaster.get('datasetId').hasError(validation.type) && (templatecreationmaster.get('datasetId').dirty || templatecreationmaster.get('datasetId').touched)">
                      {{ validation.message }}
                  </span>
              </mat-error>
              </mat-form-field>
            </div>
            
            <!-- <div style="margin-top: 1.5%;">
              <button title="Download" (click)="downloadTemplate($event);" class="btn btn-outline btn-primary btn-rounded btn-sm waves-effect waves-light" style="padding: .3rem .8rem;margin-top:0rem">
                <i class="fas fa-download"></i>
                </button>
            </div> -->
            <div class="col-lg-1"></div>
          </div>
          <div class="row topRowMargins">
            <div class="col-lg-1"></div>
            <div class="col-lg-10" style="text-align: center;">
              <mat-form-field appearance="outline">
                <mat-label i18n="@@RCselectfilter">Select Filter</mat-label>
                <mat-select [(ngModel)]="selectfilter" (selectionChange)="bindSelectFilter($event.value)" formControlName="selectfilter" multiple>
                    <mat-option *ngFor="let filterdropdown of filterstable" [value]="filterdropdown.filtermanageId" [disabled]="filterdropdown.status == 'No' || filterdropdown.isDisable">
                        {{filterdropdown.filtername}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
              </div>
              <div class="col-lg-1"></div>
          </div>
        </div>
      </div>
      <div *ngIf="reportTypeName ==='SR'">
    
        <div class="row topRowMargins">
          <div class="col-lg-1"></div>
          <div class="col-lg-10" style="text-align: center;">
            <mat-form-field appearance="outline">
              <mat-label i18n="@@RCselectfilter">Select Parent Template</mat-label>
              <mat-select [(ngModel)]="templateCreationData.parentTemplateId"
                          (selectionChange)="selectParentTemplate($event.value)"   formControlName="parentTemplateId" >
                <mat-option>None</mat-option>
                <mat-option *ngFor="let parentTemplateValues of parentTemplateDropDown"
                           [value]="parentTemplateValues.reportTemplateId">
                  {{parentTemplateValues.reportTemplateName}}
                </mat-option>
              </mat-select>
              <mat-error *ngFor="let validation of validation_messages.parentTemplateId">
                <span
                    *ngIf="templatecreationmaster.get('parentTemplateId').hasError(validation.type) && (templatecreationmaster.get('parentTemplateId').dirty || templatecreationmaster.get('parentTemplateId').touched)">
                    {{ validation.message }}
                </span>
            </mat-error>
            </mat-form-field>
          </div>
          <div class="col-lg-1"></div>
        </div>
        <div *ngIf="reportTypeName == 'SR' && (templateCreationData.parentTemplateId != null && parentTemplateType == 'vault')">
          <div class="row topRowMargins">
            <div class="col-lg-1"></div>
            <div class="col-lg-10" style="text-align: center;">
              <mat-form-field appearance="outline">
                <mat-label i18n="@@RCselectfilter">Section</mat-label>
                <mat-select [(ngModel)]="templateCreationData.binderSectionName" (selectionChange)="SelectionSelect($event.value)"
                            formControlName="binderSectionName">
                  <mat-option>None</mat-option>
                  <mat-option *ngFor="let selectValues of selectionDropDown"
                              [value]="selectValues.label__v">
                    {{selectValues.label__v}}
                  </mat-option>
                </mat-select>
                
              </mat-form-field>
            </div>
            <div class="col-lg-1"></div>
          </div>
        </div>
      </div>
      <div *ngIf="(reportTypeName == 'SR'&& (templateCreationData.parentTemplateId != null && parentTemplateType == 'vault')) || (reportTypeName == 'SA' && pushToVault)">
        <div *ngIf="reportTypeName == 'SA' || reportTypeName == 'SR'" class="row topRowMargins">
          <div class="col-lg-1"></div>
          <div class="col-lg-10" style="text-align: center;">
            <mat-form-field appearance="outline">
              <mat-label i18n="@@RCselectfilter">Doc Type</mat-label>
              <mat-select [(ngModel)]="templateCreationData.documentDocTypeLabel"
                          formControlName="documentDocTypeLabel"  (selectionChange)="documentDocTypeLabelSelect($event.value)" >
                <mat-option>None</mat-option>
                <mat-option *ngFor="let docTypeValues of docTypeDropDown" [value]="docTypeValues.docTypeLabel">
                  {{docTypeValues.docTypeLabel}}
                </mat-option>
              </mat-select>
              <mat-error *ngFor="let validation of validation_messages.documentDocTypeLabel">
                <span
                    *ngIf="templatecreationmaster.get('documentDocTypeLabel').hasError(validation.type) && (templatecreationmaster.get('documentDocTypeLabel').dirty || templatecreationmaster.get('documentDocTypeLabel').touched)">
                    {{ validation.message }}
                </span>
            </mat-error>
            </mat-form-field>
          </div>
          <div class="col-lg-1"></div>
        </div>

       

        <div *ngIf="(docSubTypeShow && reportTypeName == 'SA') || (docSubTypeShow && reportTypeName == 'SR')" class="row topRowMargins">
          <div class="col-lg-1"></div>
          <div class="col-lg-10" style="text-align: center;">
            <mat-form-field appearance="outline">
              <mat-label i18n="@@RCselectfilter">Doc Sub Type</mat-label>
              <mat-select [(ngModel)]="templateCreationData.documentDocSubTypeLabel"
                          formControlName="documentDocSubTypeLabel"  (selectionChange)="documentDocSubTypeLabelSelect($event.value)" >
                <mat-option>None</mat-option>
                <ng-container *ngFor="let docSubTypeValues of docSubTypeDropDown">
                  <mat-option *ngIf="docSubTypeValues.docSubTypeLabel && docSubTypeValues.docSubTypeLabel !== ''"
                    [value]="docSubTypeValues.docSubTypeLabel">
                    {{ docSubTypeValues.docSubTypeLabel }}
                  </mat-option>
                </ng-container>
              </mat-select>
              <mat-error *ngFor="let validation of validation_messages.documentDocSubTypeLabel">
                <span
                    *ngIf="templatecreationmaster.get('documentDocSubTypeLabel').hasError(validation.type) && (templatecreationmaster.get('documentDocSubTypeLabel').dirty || templatecreationmaster.get('documentDocSubTypeLabel').touched)">
                    {{ validation.message }}
                </span>
            </mat-error>
            </mat-form-field>
          </div>
          <div class="col-lg-1"></div>
        </div>

        <div *ngIf="(showCliassification && reportTypeName == 'SA') || (showCliassification && reportTypeName == 'SR')" class="row topRowMargins">
          <div class="col-lg-1"></div>
          <div class="col-lg-10" style="text-align: center;">
            <mat-form-field appearance="outline">
              <mat-label i18n="@@RCselectfilter">Doc Classification</mat-label>
              <mat-select [(ngModel)]="templateCreationData.documentDocClassificationLabel"
                          formControlName="documentDocClassificationLabel" (selectionChange)="documentLifeCycleForClassification($event.value)">
                <mat-option>None</mat-option>
                <mat-option *ngFor="let docClassificationValues of docClassificationDropDown" [value]="docClassificationValues.docClassificationLabel">
                  {{docClassificationValues.docClassificationLabel}}
                </mat-option>
              </mat-select>
              <mat-error *ngFor="let validation of validation_messages.documentDocClassificationLabel">
                <span
                    *ngIf="templatecreationmaster.get('documentDocClassificationLabel').hasError(validation.type) && (templatecreationmaster.get('documentDocClassificationLabel').dirty || templatecreationmaster.get('documentDocClassificationLabel').touched)">
                    {{ validation.message }}
                </span>
            </mat-error>
            </mat-form-field>
          </div>
          <div class="col-lg-1"></div>
        </div>
<!-- ******************************************************************** -->

<div *ngIf="reportTypeName == 'SA' || reportTypeName == 'SR'" class="row topRowMargins">
  <div class="col-lg-1"></div>
  <div class="col-lg-10" style="text-align: center;">
    <mat-form-field appearance="outline">
      <mat-label i18n="@@RCselectfilter">Doc Lifecycle</mat-label>
      <mat-select [(ngModel)]="templateCreationData.docLifecycle" formControlName="documentDocLifecycle">
        <mat-option>None</mat-option>
        <!-- Use *ngIf on a container element to avoid multiple template bindings -->
        <ng-container *ngFor="let docTypeValues of docLifecycleDropdown">
          <mat-option *ngIf="docTypeValues.docLifecycle && docTypeValues.docLifecycle !== ''"
            [value]="docTypeValues.docLifecycle">
            {{ docTypeValues.docLifecycle }}
          </mat-option>
        </ng-container>
      </mat-select>
      <mat-error *ngFor="let validation of validation_messages.documentDocLifecycle">
        <span
          *ngIf="templatecreationmaster.get('documentDocLifecycle').hasError(validation.type) && (templatecreationmaster.get('documentDocLifecycle').dirty || templatecreationmaster.get('documentDocLifecycle').touched)">
          {{ validation.message }}
        </span>
      </mat-error>
    </mat-form-field>
  </div>
  <div class="col-lg-1"></div>
</div>



<!-- ******************************************************************** -->

        
      </div>
      <!-- <div *ngIf="reportTypeName != 'RB'">
      <div class="row topRowMargins">
        <div class="col-lg-1"></div>
        <div class="col-lg-10" style="text-align: center;">
          <mat-form-field appearance="outline">
            <mat-label i18n="@@RCselectfilter">Dataset</mat-label>
            <mat-select [(ngModel)]="templateCreationData.datasetId"
                        formControlName="datasetId">
              <mat-option>None</mat-option>
              <mat-option *ngFor="let datasetValues of datasetDropDown" [value]="datasetValues.reportcreationid">
                {{datasetValues.datasetname}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div style="margin-top: 1.5%;">
          <button title="Download" (click)="downloadTemplate($event);" class="btn btn-outline btn-primary btn-rounded btn-sm waves-effect waves-light" style="padding: .3rem .8rem;margin-top:0rem">
            <i class="fas fa-download"></i>
            </button>
        </div>
        <div class="col-lg-1"></div>
      </div>
    </div> -->
      <div *ngIf="reportTypeName == 'SA' || reportTypeName == 'SR' ">
        
        <div class="row topRowMargins">
          <div class="col-lg-1"></div>
          <div class="col-lg-10" style="text-align: center;">
            <mat-form-field appearance="outline">
              <mat-label i18n="@@RCselectfilter">Dataset</mat-label>
              <mat-select [(ngModel)]="this.templateCreationData.datasetId"
                          formControlName="datasetId"
                          (selectionChange)="retriveManageFilters($event.value)">
                <mat-option>None</mat-option>
                <mat-option *ngFor="let datasetValues of datasetDropDown" [value]="datasetValues.reportcreationid">
                  {{datasetValues.datasetname}}
                </mat-option>
              </mat-select>
              <mat-error *ngFor="let validation of validation_messages.datasetId">
                <span
                    *ngIf="templatecreationmaster.get('datasetId').hasError(validation.type) && (templatecreationmaster.get('datasetId').dirty || templatecreationmaster.get('datasetId').touched)">
                    {{ validation.message }}
                </span>
            </mat-error>
            </mat-form-field>
          </div>
          
          <div style="margin-top: 1.5%;">
            <button title="Download" (click)="downloadTemplate($event);" class="btn btn-outline btn-primary btn-rounded btn-sm waves-effect waves-light" style="padding: .3rem .8rem;margin-top:0rem">
              <i class="fas fa-download"></i>
              </button>
          </div>
          <div class="col-lg-1"></div>
        </div>
        <div class="row topRowMargins">
          <div class="col-lg-1"></div>
          <div class="col-lg-10" style="text-align: center;">
            <mat-form-field appearance="outline">
              <mat-label i18n="@@RCselectfilter">Select Filter</mat-label>
              <mat-select [(ngModel)]="selectfilter" (selectionChange)="bindSelectFilter($event.value)" formControlName="selectfilter" multiple>
                  <mat-option *ngFor="let filterdropdown of filterstable" [value]="filterdropdown.filtermanageId" [disabled]="filterdropdown.status == 'No' || filterdropdown.isDisable">
                      {{filterdropdown.filtername}}
                  </mat-option>
              </mat-select>
          </mat-form-field>
            </div>
            <div class="col-lg-1"></div>
        </div>
        <div *ngIf=" reportTypeName == 'SR' " class="row topRowMargins">
          <div class="col-lg-1"></div>
          <!-- <div class="col-lg-10" style="text-align: center;">
              <mat-form-field appearance="outline">
                  <mat-label i18n="@@RCselectfilter">Select Filter</mat-label>
                  <mat-select [(ngModel)]="selectfilter" (selectionChange)="bindSelectFilter($event.value)" formControlName="selectfilter" multiple>
                     
                      <mat-option *ngFor="let filterdropdown of filterstable" [value]="filterdropdown.filtermanageId">
                          {{filterdropdown.filtername}}
                      </mat-option>
                  </mat-select>
              </mat-form-field>
          </div> -->
          <div class="col-lg-1"></div>
      </div>


        <div class="row topRowMargins">
          <div class="col-lg-1"></div>
          <div class="col-lg-10" style="text-align: center;">
            <mat-form-field appearance="outline">
              <mat-label i18n="@@RCselectfilter">Template Type</mat-label>
              <mat-select [(ngModel)]="this.templateCreationData.templateType"
                          (selectionChange)="templateTypeSelect($event)"
                          formControlName="templateType" >
                <mat-option>None</mat-option>
                <mat-option *ngFor="let templateTypeValues of templateTypeDropDown" [value]="templateTypeValues.lookupvalueid">
                  {{templateTypeValues.lookupvalue}}
                </mat-option>
              </mat-select>
              <mat-error *ngFor="let validation of validation_messages.templateType">
                <span
                    *ngIf="templatecreationmaster.get('templateType').hasError(validation.type) && (templatecreationmaster.get('templateType').dirty || templatecreationmaster.get('templateType').touched)">
                    {{ validation.message }}
                </span>
            </mat-error>
            </mat-form-field>
          </div>
          <div class="col-lg-1"></div>
        </div>
       

        <div class="row topRowMargins" *ngIf="templateTypeName ==='PDF' || templateTypeName ==='XLSX' ">
          <div class="col-lg-1"></div>
          <div class="col-lg-8" style="text-align: center;">
            <mat-form-field appearance="outline">
              <mat-label i18n="@@RCselectfilter">Choose Template File</mat-label>
              <input matInput type="text" formControlName="templateFile"
                     [(ngModel)]="templateCreationData.templateFileName" readonly >
                     <mat-error *ngFor="let validation of validation_messages.templateFile">
                      <span
                          *ngIf="templatecreationmaster.get('templateFile').hasError(validation.type) && (templatecreationmaster.get('templateFile').dirty || templatecreationmaster.get('templateFile').touched)">
                          {{ validation.message }}
                      </span>
                  </mat-error>
            </mat-form-field>


          </div>
          <div class="col-lg">
            <div class="file-field" style="width: 20%;margin-right: 10px;">
              <a class="btn-floating  btn-sm ml-4 m-0">
                <em class="fas fa-paperclip mt-0" style="text-rendering: auto;color:black"></em>
                <input type="file" id="imageupload" name="imageupload" (change)="uploadFile($event)">
              </a>
            </div>
          </div>
          <div class="col-lg-1"></div>
        </div>
<!-- ====================================1111111111========================================= -->
<div class="row topRowMargins" *ngIf="templateTypeName ==='Document'">
  <div class="col-lg-1"></div>
  <div class="col-lg-8" style="text-align: center;">
    <mat-form-field appearance="outline">
      <mat-label i18n="@@RCselectfilter">Choose Template File</mat-label>
      <input matInput type="text" formControlName="templateFile" [(ngModel)]="templateCreationData.templateFileName"
        readonly>
      <mat-error *ngFor="let validation of validation_messages.templateFile">
        <span
          *ngIf="templatecreationmaster.get('templateFile').hasError(validation.type) && (templatecreationmaster.get('templateFile').dirty || templatecreationmaster.get('templateFile').touched)">
          {{ validation.message }}
        </span>
      </mat-error>
    </mat-form-field>


  </div>
  <div class="col-lg">
    <div class="file-field" style="width: 20%;margin-right: 10px;">
      <a class="btn-floating  btn-sm ml-4 m-0">
        <em class="fas fa-paperclip mt-0" style="text-rendering: auto;color:black"></em>
        <input type="file" id="imageupload" name="imageupload" (change)="uploadFile($event)">
      </a>
    </div>
  </div>
  <div class="col-lg-1"></div>
</div>

<!-- ==================================2222================================ -->

<div class="row topRowMargins" *ngIf="templateTypeName ==='Document'">
  <div class="col-lg-1"></div>
  <div class="col-lg-8" style="text-align: center;">
    <mat-form-field appearance="outline">
      <mat-label i18n="@@RCselectfilter">Choose Configuration File</mat-label>
      <input matInput type="text" formControlName="configFile" [(ngModel)]="templateCreationData.configFileName"
        readonly>
      <mat-error *ngFor="let validation of validation_messages.configFile">
        <span
          *ngIf="templatecreationmaster.get('configFile').hasError(validation.type) && (templatecreationmaster.get('configFile').dirty || templatecreationmaster.get('configFile').touched)">
          {{ validation.message }}
        </span>
      </mat-error>
    </mat-form-field>


  </div>
  <div class="col-lg">
    <div class="file-field" style="width: 20%;margin-right: 10px;">
      <a class="btn-floating  btn-sm ml-4 m-0">
        <em class="fas fa-paperclip mt-0" style="text-rendering: auto;color:black"></em>
        <input type="file" id="imageupload" name="imageupload" (change)="uploadConfigFile($event)">
      </a>
    </div>
  </div>
  <div class="col-lg-1"></div>
</div>

 <!-- ======================================2222======================================== -->

        <div class="row topRowMargins" *ngIf="templateTypeName ==='QS';">
          <div class="col-lg-1"></div>
          <div class="col-lg-10" style="text-align: center;">
            <mat-form-field appearance="outline">
              <mat-label i18n="@@RCselectfilter">QuickSight reference</mat-label>
              <input matInput type="text" formControlName="quickSightReference"
                     [(ngModel)]="templateCreationData.quickSightReference" required>
                     <mat-error *ngFor="let validation of validation_messages.quickSightReference">
                      <span
                          *ngIf="templatecreationmaster.get('quickSightReference').hasError(validation.type) && (templatecreationmaster.get('quickSightReference').dirty || templatecreationmaster.get('quickSightReference').touched)">
                          {{ validation.message }}
                      </span>
                  </mat-error>
            </mat-form-field>
          </div>
          <div class="col-lg-1"></div>
        </div>
      </div>
      <div class="row topRowMargins">
  <div class="col-lg-1"></div>
  <div class="col-lg-10" style="text-align: center;">
    <mat-form-field appearance="outline">
      <mat-label i18n="@@ReportOutputFormat">Report Dataset Output Format</mat-label>
      <mat-select [(ngModel)]="reportOutputFormat"
                  formControlName="reportOutputFormat"
                  required>
        <mat-option *ngFor="let format of reportOutputTypes" [value]="format.lookupvalue">
          {{format.lookupvalue}}
        </mat-option>
      </mat-select>
      <mat-error *ngFor="let validation of validation_messages.reportOutputFormat">
        <span *ngIf="templatecreationmaster.get('reportOutputFormat').hasError(validation.type) 
                     && (templatecreationmaster.get('reportOutputFormat').dirty || 
                         templatecreationmaster.get('reportOutputFormat').touched)">
          {{ validation.message }}
        </span>
      </mat-error>
    </mat-form-field>
  </div>
  <div class="col-lg-1"></div>
</div>
   

    </form>
    <div class="col-lg">
      <div class="container" style="text-align: center;">
        <div class="row topRowMargins">

          <div class="col-lg">

            <div style="text-align: end">

              <button i18n="@@TMRunButton" type="button" (click)="save()" class="btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" [style.background-color]="backgroundColorButton"
                      style="padding:0.4rem 1.6rem 0.4rem;font-size: 0.91rem;color: white;">{{buttonName}}
              </button>

              <button i18n="@@TMRunButton" type="button" (click)="cancel()" class="cancelButton btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" [style.border-color]="backgroundColorButton"
                      style="padding:0.4rem 1.6rem 0.3rem 1.6rem;font-size: 0.90rem;background-color: white !important;color: black;border-width: 1px;border-style: solid;">Cancel
              </button>

            </div>

          </div>

        </div>
      </div>
    </div>
  </div>

</div>
